import { HireMode } from '@/types/common';

/**
 * 候选人确认状态
 */
export enum HeadhunterConfirmed {
  HR_PENDING = 0, // hr未处理
  HR_AGREE = 1, // hr同意
  HR_REJECT = 2, // hr拒绝

  CA_PENDING = 3, // 候选人待确认
  CA_REJECT = 4, // 候选人拒绝
  CA_EXPIRE = 5, // 候选人失效
}

export interface Application {
  appliedAt: number;
  archiveDetail: string;
  archiveReasonId: number;
  archiveReasonName: string;
  archiveReasonType: number;
  archived: boolean;
  candidateId: number;
  deleted: boolean;
  downloadUrl: string;
  duplicateWhenUpload: boolean;
  email: string;
  expireAt: string;
  fullPhone: string;
  hasSimilar: boolean;
  headhunterConfirmed: HeadhunterConfirmed;
  headhunterType: 1 | 2;
  operatedAt: string;
  hired: boolean;
  hireMode: HireMode;
  id: number;
  job: {
    id: string;
    jobTitle: string;
  };
  jobCommitment: string;
  jobId: string;
  jobTitle: string;
  name: string;
  orgId: string;
  phone: string;
  rpoBatchNo: number;
  stageId: number;
  stageName: string;
  stageStatus: string;
  stageType: number;
  rejectReason: string;
  updatedAt: string;
}
